import {DateRangeAttributes} from 'common/widgets/date-range-picker/models/types';
import type {CohortSegment} from 'common/query-builder/query-block/segment-menu/types';
import {PropertyType} from 'common/types/reports/bookmark';

export * from 'common/types/reports/bookmark-filters';

export const PropertyTypeSet = new Set(Object.values(PropertyType));

// // TODO(micah): the Partial<DateRangeAttributes> is wrong, filter value shouldn't be partial. but the types are messed up in cohorts transformations as it has a conflicting date type
export type FilterOperand = string | boolean | number | Partial<DateRangeAttributes> | CohortSegment;
export type FilterValue = FilterOperand | FilterOperand[];

export enum DisplayContext {
  Cohorts = `cohorts`,
  CustomEvent = `custom_event`,
  Default = `default`,
  Insights = `insights`,
  Signal = `signal`,
}
